<template>
    <div class="container my-5 addmargin2">
      <h2 class="mb-4 titleblue">Formulaire de témoignage</h2>
  
      <form ref="form" @submit.prevent="sendEmail" enctype="multipart/form-data">
        <h4 class="titleblue">À propos de vous</h4>
        <div class="row mb-3">
          <div class="col">
            <input type="text" class="form-control" placeholder="Votre nom" v-model="form.nom" name="user_name" required />
          </div>
          <div class="col">
            <input type="text" class="form-control" placeholder="Votre prénom" v-model="form.prenom" name="user_prenom" required />
          </div>
        </div>
  
        <div class="mb-3">
          <input type="email" class="form-control" placeholder="Adresse email" v-model="form.email" name="user_email" required />
        </div>
  
        <div class="mb-3">
          <input type="tel" class="form-control" placeholder="Téléphone" v-model="form.telephone" name="user_telephone" />
        </div>
  
        <h4 class="titleblue">À propos de l'événement</h4>
        <div class="mb-3">
          <input type="text" class="form-control" placeholder="Nom de l'animal si connu" v-model="form.animal" name="user_animal" />
        </div>
  
        <div class="mb-3">
          <input type="text" class="form-control" placeholder="Lieu" v-model="form.lieu" name="user_lieu" required />
        </div>
  
        <div class="mb-3">
          <textarea
            class="form-control"
            placeholder="Expliquez ce que vous avez vu"
            v-model="form.temoignage"
            name="user_temmoignage"
            rows="5"
            required
          ></textarea>
        </div>
  
        <h4 class="titleblue">Date et heure de l'événement</h4>
        <div class="mb-3">
          <input type="date" class="form-control" v-model="form.date" name="user_date" required />
        </div>
  
        <div class="row mb-3">
          <div class="col">
            <input type="number" class="form-control" placeholder="Heures (ex: 08)" v-model="form.heure" name="user_heure" min="0" max="23" />
          </div>
          <div class="col">
            <input type="number" class="form-control" placeholder="Minutes (ex: 00)" v-model="form.minutes" name="user_minutes" min="0" max="59" />
          </div>
        </div>
  
        <button type="submit" class="btn btn-primary">Envoyer</button>
      </form>
    </div>
  </template>
  
  <script>
  import emailjs from '@emailjs/browser';
  import { reactive } from 'vue';
  
  export default {
    data() {
      return {
        form: reactive({
          nom: '',
          prenom: '',
          email: '',
          telephone: '',
          animal: '',
          lieu: '',
          temoignage: '',
          date: '',
          heure: '',
          minutes: '',
          file: null,
        }),
      };
    },
  
    methods: {
      handleFileUpload(event) {
        const file = event.target.files[0];
        this.form.file = file;
      },
  
      async sendEmail() {
        const formData = new FormData();
        for (const key in this.form) {
          formData.append(key, this.form[key]);
        }
  
        try {
          const response = await emailjs.sendForm(
            'service_po7w4mg', // SERVICE_ID
            'template_wnf5a32', // TEMPLATE_ID
            this.$refs.form,    // Formulaire référencé
            'sUJbzYSTZIrMUYQaz' // PUBLIC_KEY
          );
          
          console.log('SUCCESS!', response);
          alert('Le témoignage a bien été envoyé !');
        } catch (error) {
          console.error('FAILED...', error.text);
          alert('Une erreur est survenue, veuillez réessayer.');
        }
      },
    },
  };
  </script>
  
  <style scoped>
  h4 {
    margin-top: 2rem;
  }
  </style>
  